import * as React from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import SolutionHeart from "assets/images/solution-heart.png";
import SolutionTime from "assets/images/solution-time.png";
import SolutionQrCode from "assets/images/solution-qrcode.png";

const solutions = [
  {
    image: SolutionHeart,
    bgColor: "#E6EFEA",
    title: "Для підприємців",
    text: "Ідеально підходить для ФОПів, які приймають платежі по IBAN — без ПРРО, без комісій, без зайвих дій.",
  },
  {
    image: SolutionTime,
    bgColor: "#E3E4EA",
    title: "Для клієнтів",
    text: "Це зручний спосіб здійснити оплату по IBAN без зайвих кроків, користуючись своїми банківськими застосунками.",
  },
  {
    image: SolutionQrCode,
    bgColor: "#EFECE6",
    title: "Для бізнесу",
    text: "Автоматизація платіжних посилань за допомогою API-інтеграції сервісу з вашими CRM та іншими бізнес-платформами.",
  },
];

const Solution: React.FC = () => {
  return (
    <Container sx={styles.solutionsBlock}>
      <Box>
        <Typography variant="subtitle1" color="error.dark">
          заощаджуйте час своїх покупців
        </Typography>
        <Typography variant="h2" sx={{ whiteSpace: "pre-line", mt: 2, mb: 6 }}>
          <Typography variant="h2" color="primary" sx={{ display: "inline" }}>
            IBAN oplata
          </Typography>{" "}
          знижує ризик помилок та {`\n`}пришвидшує процес оплати
        </Typography>
      </Box>
      <Box sx={styles.solutionsWrapper}>
        {solutions.map((solution, index) => (
          <Box
            key={index}
            sx={[styles.solution, { backgroundColor: solution.bgColor }]}
            p={5}
            m={1}
          >
            <img src={solution.image} />
            <Typography variant="h3" sx={{ mb: 1.5, mt: 5 }}>
              {solution.title}
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 400 }}>
              {solution.text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Container>
  );
};

const styles = {
  solutionsBlock: {
    textAlign: "center",
    paddingTop: { xs: "56px", sm: "120px" },
    paddingBottom: { xs: "56px", sm: "120px" },
  },
  solutionsWrapper: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: { xs: "center", md: "space-between" },
    alignItems: { xs: "center", md: "stretch" },
  },
  solution: {
    width: { xs: "100%", sm: "70%", md: "100%" },
  },
};

export default Solution;
